import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "input-group input-group-password" }
const _hoisted_2 = ["name", "id", "type", "disabled", "placeholder"]
const _hoisted_3 = {
  key: 1,
  class: "invalid-feedback",
  role: "alert"
}

import { ref, toRef } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false,
},
  __name: 'PasswordInput',
  props: /*@__PURE__*/_mergeModels({
    type: {
        type: String,
        default: "text",
        required: false,
    },
    name: {
        type: String,
        required: true,
    },

    error: {
        type: String,
        default: null,
    },
    showPassword: {
        type: Boolean,
        default: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    placeholder: {
        type: String,
        default: "",
    },
    maxLength: {
        type: Number,
        default: null,
    },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {


const model = _useModel(__props, "modelValue");
const props = __props;

const emit = __emit;

const name = toRef(props, "name");

const passwordVisible = ref(false);

const togglePasswordVisibility = () => {
    passwordVisible.value = !passwordVisible.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      name: name.value,
      id: name.value,
      class: _normalizeClass(["form-control rounded", { 'is-invalid': !!__props.error }]),
      type: passwordVisible.value ? 'text' : 'password',
      disabled: __props.disabled,
      placeholder: __props.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
    }, null, 10, _hoisted_2), [
      [_vModelDynamic, model.value]
    ]),
    (__props.showPassword)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn",
          onClick: togglePasswordVisibility
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(passwordVisible.value ? 'bi bi-eye-slash-fill' : 'bi-eye-fill')
          }, null, 2)
        ]))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})